import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from "@angular/core";
import { CommunityService, UserService } from "@mypxplat/xplat/core";

import { SelectListItemBaseComponent } from "@mypxplat/xplat/features";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "myp-select-list-item",
  templateUrl: "select-list-item.component.html",
  standalone: false,
})
export class SelectListItemComponent extends SelectListItemBaseComponent {
  constructor(
    userService: UserService,
    public activeModal: NgbActiveModal,
    public communityService: CommunityService
  ) {
    super(userService);
  }

  ngOnInit() {}
}
